module.exports = __webpack_public_path__ + "img/calculationFlow.945db9e7.png";